"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Svg_1 = require("./Svg");
const Path_1 = require("./Svg/Path");
const Wishlist = ({ color = 'primary', ...rest }) => (React.createElement(Svg_1.default, Object.assign({}, rest),
    React.createElement(Path_1.default, { isStroke: true, d: "M12 22.25L2.625 12.087C.937 10.333.518 7.654 1.585 5.435 2.385 3.778 3.9 2.621 5.66 2.325c1.76-.298 3.55.303 4.81 1.613L12 5.528l1.531-1.59c1.26-1.31 3.05-1.91 4.81-1.614 1.76.297 3.276 1.454 4.074 3.111 1.067 2.219.649 4.898-1.04 6.652L12 22.25z", color: color, strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" })));
exports.default = Wishlist;
